import ConflictBeoordelingApi from "../../../api/e-loket/conflictBeoordelingApi";
import { mapBoundsOfGeoJson } from "../../common/map/GpxService";

export default class ConflictBeoordelingPageHelper {

    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        const params = context.props.match.params;
        const gpxConflictId = params.gpxConflictId;
        ajaxActions.started();
        ConflictBeoordelingApi.get(gpxConflictId)
            .then((response) => {
                ajaxActions.ended();
                this.processModel(response);
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

    processModel(response) {
        const context = this.context;
        let model = response.data;

        model.bestaandeLus.geoJson = JSON.parse(model.bestaandeLus.geoJson);
        model.gewijzigdeLus.geoJson = JSON.parse(model.gewijzigdeLus.geoJson);

        context.setState({
            model: model,
            customBounds: [
                ...mapBoundsOfGeoJson(model.gewijzigdeLus.geoJson),
                ...mapBoundsOfGeoJson(model.bestaandeLus.geoJson)
            ]
        });
    }

    closePage(){
        window.close();
    }

    beoordeelConflict(isConflict) {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        const params = context.props.match.params;
        const gpxConflictId = params.gpxConflictId;
        ajaxActions.started();
        ConflictBeoordelingApi.beoordeelConflict(gpxConflictId, isConflict)
                .then(() => {
                    ajaxActions.ended();
                    this.closePage();
                })
                .catch((ex) => {
                    ajaxActions.failed();
                    context.props.throwException(ex);
                });
    }


}
